import { Done } from '@mui/icons-material';
import { Stack, ToggleButton, ToggleButtonGroup } from '@mui/material';
import React from 'react';

interface IProps {
  selectedValueId: string;
  values: { id: string; value: React.ReactNode }[];
  onChange: (id: string) => void;
}

export function FSToggleButtonGroup({
  selectedValueId,
  values,
  onChange,
}: IProps) {
  const handleChange = (
    event: React.MouseEvent<HTMLElement>,
    newValue: string | null,
  ) => {
    if (newValue) {
      onChange(newValue);
    }
  };

  return (
    <ToggleButtonGroup
      value={selectedValueId}
      onChange={handleChange}
      exclusive
      size="small"
    >
      {values.map((x) => (
        <ToggleButton
          key={x.id}
          value={x.id}
          sx={{ borderRadius: 15, textTransform: 'none', px: 3 }}
        >
          <Stack direction={'row'} spacing={1} alignItems={'center'}>
            {selectedValueId === x.id && <Done sx={{ fontSize: '1.125rem' }} />}
            {x.value}
          </Stack>
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
}
